import React from 'react';
import { Box, Skeleton } from '@mui/material';

/**
 * Skeleton for programme list items (time block + title + description).
 * @param {number} count - Number of skeleton rows to show
 */
export function ProgrammeListSkeleton({ count = 5 }) {
  return (
    <Box sx={{ width: '100%', maxWidth: 800, mx: 'auto' }}>
      {Array.from({ length: count }).map((_, i) => (
        <Box
          key={i}
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 2,
            py: 2,
            mb: 2,
            borderBottom: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Skeleton
            variant="rounded"
            width={80}
            height={36}
            sx={{ flexShrink: 0, borderRadius: 1 }}
          />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width="70%" height={28} sx={{ mb: 1 }} />
            <Skeleton variant="text" width="90%" height={20} sx={{ mb: 0.5 }} />
            <Skeleton variant="text" width="50%" height={18} />
          </Box>
        </Box>
      ))}
    </Box>
  );
}
